import React, { useRef, useLayoutEffect, useState } from "react";
import { Calendar, FileStack } from 'lucide-react';
import { Timeline } from 'primereact/timeline';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const StepProgressBar = ({ steps, currentStep, onClick}) => {
  const events = [
    { status: 'Stage 1', start: '15/10/2020 ', status2: 'Completed', end: '15/10/2020', contribution: 15 ,activities: 60 },
    { status: 'Stage 2', start: '15/10/2020', status2: 'Completed', end: '15/10/2020', contribution: 15 ,activities: 90 },
    { status: 'Stage 3', start: '15/10/2020', status2: 'In Progress', end: '16/10/2020', contribution: 14 ,activities: 80 },
    { status: 'Stage 4', start: '16/10/2020', status2: 'Pending', end: '16/10/2020', contribution: 14 ,activities: 70 },
    { status: 'Stage 5', start: '16/10/2020', status2: 'Pending', end: '16/10/2020', contribution: 14 ,activities: 110 },
    { status: 'Stage 6', start: '16/10/2020', status2: 'Pending', end: '16/10/2020', contribution: 14 ,activities: 120 },
    { status: 'Stage 7', start: '16/10/2020', status2: 'Pending', end: '16/10/2020', contribution: 14 ,activities: 130 },
  ];

const customizedMarker = (item) => {
    return (
        <span className={`px-3 py-2 rounded-full text-2xl text-white ${item.status2 === 'Completed' ? 'bg-green-800' :
          item.status2 === 'Pending' ? 'bg-red-800' : 'bg-yellow-600'} ${item.status2 === 'In Progress' ? 'border-2 border-yellow-600 glow-animation ripple-container' : ''}`} >
            <i className={item.status2 === 'Completed' ? 'pi pi-check text-2xl ' : item.status2 === 'Pending' ? 'pi pi-clock text-2xl ' : 'pi pi-exclamation-triangle text-2xl '}></i>
        </span>
    );
};

const customizedContent = (item) => {
    return (
        <div className={`shadow-lg rounded-lg p-6 mb-4 border-1 ${item.status2 === 'Completed' ? 'bg-green-50 border-green-300' : item.status2 === 'Pending' ? 'bg-red-50 border-red-300' : 'bg-yellow-50 border-yellow-300 glow-animation '}`}>
          <h3 className="text-xl font-bold text-gray-800 mb-2">{item.status}</h3>
          <div className=" text-sm text-gray-600 mb-2">
            <i className="pi pi-calendar-minus text-green-700 mr-1"></i>
            <span>{item.start}</span>
            <span className="mx-2">-</span>
            <i className="pi pi-calendar-minus text-orange-700 mr-1"></i>
            <span>{item.end}</span>
          </div>
          <div className="my-2">
            <span className={`px-2 py-1 rounded-full text-xs font-medium inline-flex items-center gap-2 ${item.status2 === 'Completed' ? 'bg-green-100 text-green-800' : item.status2 === 'Pending' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800 border-1 border-yellow-400 glow-animation '}`}>
              <span style={{ display: 'inline-block', width: 16, height: 16, background: item.status2 === 'Completed' ? 'rgb(22 101 52 / 1)' : item.status2 === 'Pending' ? 'rgb(220 38 38 / 1)' : 'rgb(250 204 21 / 1)', borderRadius: '50%' }}></span>
              {item.status2}
            </span>
          </div>
          <div className="text-sm text-blue-700 mb-2">
            <span>{item.contribution}% of total Allocated budget = </span>
            <span className="font-bold">{(2000 * item.contribution) / 100}Cr</span>
          </div>
          <div className="text-sm text-gray-700 mb-4">
            <span>Number Of Activities: {item.activities}</span>
          </div>
          <button className="text-blue-500 hover:text-blue-700 font-medium" onClick={onClick}>
            <i className="pi pi-arrow-left mr-1"></i>Read more
          </button>
        </div>
    );
};
    
return (
    <div className="card py-2 px-10 border-1 rounded-lg border-indigo-300 bg-indigo-50">
        <Timeline value={events} align="alternate" className="customized-timeline mx-8" marker={customizedMarker} content={customizedContent} />
    </div>
)
};

export default StepProgressBar; 